export default class {
    getCoordinatesFromShape(shape) {
        if (shape instanceof google.maps.Polygon) {
            return this.getCoordinatesFromPolygonShape(shape);
        } else if (shape instanceof google.maps.Rectangle) {
            return this.getCoordinatesFromRectangleShape(shape);
        } else if (shape instanceof google.maps.Marker) {
            return this.getCoordinatesFromMarker(shape);
        } else if (shape instanceof google.maps.Polyline) {
            return this.getCoordinatesFromPolyline(shape);
        }

        return [];
    }

    getCoordinatesFromPolygonShape(shape) {
        const coordinates = [];
        const vertices = shape.getPath();

        for (let i = 0; i < vertices.getLength(); i++) {
            coordinates.push(vertices.getAt(i));
        }

        return coordinates;
    }

    getCoordinatesFromRectangleShape(shape) {
        const bounds = shape.getBounds();

        const northEast = bounds.getNorthEast();
        const southWest = bounds.getSouthWest();
        const southEast = new google.maps.LatLng(southWest.lat(), northEast.lng());
        const northWest = new google.maps.LatLng(northEast.lat(), southWest.lng());

        return [northEast, southEast, southWest, northWest];
    }

    getCoordinatesFromMarker(shape) {
        return shape.getPosition().lat() + ' ' + shape.getPosition().lng();
    }

    getCoordinatesFromPolyline(shape) {
        const coordinates = shape.getPath().getArray();

        // Two coordinates is required to make up a polyline
        if (coordinates.length < 2) {
            return null;
        }

        return coordinates;
    }

    getStringifiedCoordinates(coordinates) {
        const polygon = [];

        if (coordinates.length) {
            for (let i = 0; i <= coordinates.length; i++) {
                const key = (i !== coordinates.length) ? i : 0;
                polygon.push(coordinates[key].lat() + ' ' + coordinates[key].lng());
            }
        }

        return polygon;
    }
}